export default __webpack_public_path__ + "static/media/alaska.516759d6.jpg";